import { BehaviorOrientation } from './BehaviorOrientation'
import { BehaviorRandomOffset } from './BehaviorRandomOffset'
import { BehaviorConnections } from './BehaviorConnections'

export const behaviors = {
  orientation: BehaviorOrientation,
  randomOffset: BehaviorRandomOffset,
  connections: BehaviorConnections,
}
